var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-10"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex flex-row justify-center mobile-one-col"
  }, [_c('CardTile', {
    staticStyle: {
      "--duration": ".5s"
    },
    attrs: {
      "className": "slide-fade-right",
      "header": "End-to-End Ownership",
      "headerClass": "text-3xl"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm._v("Designs, builds, and ships production systems from UX through backend and deployment")];
      },
      proxy: true
    }])
  }), _c('CardTile', {
    staticStyle: {
      "--duration": "1s"
    },
    attrs: {
      "className": "slide-fade-right",
      "header": "Product-Minded Engineering",
      "headerClass": "text-3xl"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm._v("Turns ambiguous business problems into reliable, user-facing solutions")];
      },
      proxy: true
    }])
  }), _c('CardTile', {
    staticStyle: {
      "--duration": "1.5s"
    },
    attrs: {
      "className": "slide-fade-right",
      "header": "Systems at Scale",
      "headerClass": "text-3xl"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm._v("Builds and operates high-impact systems with strong performance, consistency, and reliability")];
      },
      proxy: true
    }])
  }), _c('CardTile', {
    staticStyle: {
      "--duration": "2s"
    },
    attrs: {
      "className": "slide-fade-right",
      "header": "Execution & Leadership",
      "headerClass": "text-3xl"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm._v("Drives technical design, mentors engineers, and improves team velocity through pragmatic process")];
      },
      proxy: true
    }])
  })], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-row justify-between mobile-one-col"
  }, [_c('div', {
    staticClass: "flex flex-column justify-center items-center",
    staticStyle: {
      "flex-basis": "40%"
    }
  }, [_c('div', {
    staticClass: "flex flex-col justify-center flex-nowrap text-6xl font-normal leading-normal mt-0 mb-1 p-2",
    staticStyle: {
      "color": "#60789e"
    }
  }, [_c('span', {
    staticClass: "slide-in-from-left"
  }, [_c('div', [_vm._v("Erik ")]), _c('div', [_vm._v("Dietrich")])]), _c('div', {
    staticClass: "fade-in flex flex-row justify-around text-2xl"
  }, [_c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/erik-dietrich-000506134/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "hover-grow cursor-pointer fab fa-linkedin"
  })]), _c('a', {
    attrs: {
      "href": "https://github.com/erikd7",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "hover-grow cursor-pointer fab fa-github"
  })]), _c('a', {
    attrs: {
      "href": "https://wellfound.com/u/erik-dietrich-1",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "hover-grow cursor-pointer fab fa-angellist"
  })])])])]), _c('div', {
    staticClass: "fade-in mt-0 mb-1 p-2 flex flex-row justify-center",
    staticStyle: {
      "--duration": ".5s"
    }
  }, [_c('img', {
    staticClass: "image-display",
    attrs: {
      "src": require("../data/coverPhoto.jpeg")
    }
  })]), _c('div', {
    staticClass: "flex flex-col flex-grow justify-center items-stretch font-normal leading-normal mt-0 mb-1 p-2",
    staticStyle: {
      "color": "#60789e"
    }
  }, [_c('div', {
    staticClass: "slide-fade-right text-left text-4xl"
  }, [_vm._v(" Full stack engineer ")]), _c('div', {
    staticClass: "slide-fade-left text-center text-2xl"
  }, [_vm._v(" designing, building, and continuously improving end-to-end systems ")])])]);
}]

export { render, staticRenderFns }